"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LISTER_ID = exports.LISTER_NO_RESULTS_PATH = void 0;
exports.LISTER_NO_RESULTS_PATH = 'lister/no-results';
exports.LISTER_ID = 'product-tile-lister';
//# sourceMappingURL=ListerConstants.js.map